<div [ngClass]="{ spacer: alternatives[0] === '3900' }" class="container">
  <div class="text">{{ errorMessage | translate }}</div>
  <div class="alternatives" *ngFor="let alt of alternatives; let i = index">
    <div class="alternative" (click)="setAlternativeValue(alt)">
      &nbsp;{{ alt }}mm
      <span class="text" *ngIf="i + 1 < alternatives.length">of</span>
    </div>
  </div>
  <span class="text">.</span>
</div>
